import { Theme } from '@mui/material/styles'

export const getPopoverContentStyles = (theme: Theme) => ({
  divider: {
    borderTop: '1px dashed #979797',
    marginTop: theme.spacing(0.5),
  },

  button: { marginLeft: 'auto' },
  spinner: { margin: 'auto' },
})
